export const FIREBASE_INIT = 0x01;
export const ACTIVE_PAGE = 0x10;
export const SHOW_LOADING = 0x11;
export const SHOW_MESSAGE = 0x12;
export const FETCH_PRODUCT_CATEGORIES = 0x21;
export const CHANGE_PRODUCT_CATEGORY = 0x22;
export const GET_PRODUCTS = 0x23;
export const GET_PRODUCT_OPTIONS = 0x24;
export const GET_PRODUCT_MATERIALS = 0x25;
export const GET_PRODUCT_COSTS = 0x26;
export const ADD_PRODUCT_PRICING = 0x27;
export const GET_PRODUCT_PRICING = 0x28;
export const UPDATE_PRODUCT_PRICING = 0x29;
export const GET_BOOKLET_PRICING = 0x2A;
export const UPDATE_BOOKLET_PRICING = 0x2B;
export const UPDATE_PRODUCT_MATERIALS = 0x2C;
export const GET_STICKER_PRICING = 0x2D;
export const UPDATE_STICKER_PRICING = 0x2E;
export const GET_MATERIAL_LIST = 0x2F;
export const GET_ORDERS = 0x30;
export const SET_ORDER_FILTER = 0x32;
export const UPDATE_ORDER = 0x33;
export const BANKSLIP_UPLOAD = 0x34
export const BANKSLIP_UPLOAD_COMPLETE = 0x35;
export const EXPORT_ORDERS_REPORT = 0x36;
export const EXPORT_SALES_REPORT = 0x37;
export const GET_SALES_REPORT = 0x38;
export const GET_SALES_REPORT_BY_ID = 0x39;
export const SORT_SALES_REPORT = 0x3A;
export const OPEN_CUSTOM_MODAL = 0x3B;
export const GET_CUSTOMERS = 0x40;
export const GET_CUSTOMER_BY_ID = 0x41;
export const SORT_CUSTOMERS = 0x42;
export const OPEN_ADD_CUSTOMER_MODAL = 0x43;
export const LOGIN = 0x60;
export const LOGOUT = 0x61;
export const OPEN_ADD_STAFF_MODAL = 0x62;
export const GET_STAFFS = 0x63;
export const GET_STAFF_BY_ID = 0x64;
export const SORT_STAFFS = 0x65;
export const RETRIEVE_CREDIT_RECORDS = 0x66;
export const TOPUP_CREDIT = 0x67;
export const GET_CREDIT_REPORT = 0x68;
export const OPEN_VOUCHER_MODAL = 0x70;
export const GET_VOUCHERS = 0x71;
export const CREATE_VOUCHER = 0x72;
export const DELETE_VOUCHER = 0x73;
export const VERIFY_VOUCHER = 0x74;
export const CLEAR_VOUCHER = 0x75;
export const GET_LOGIN_RECORDS = 0x80;
export const GET_LOGIN_RECORDS_BY_ID = 0x81;
export const SORT_LOGIN_RECORDS = 0x82;
export const OPEN_HOLIDAY_MODAL = 0x83;
export const ADD_HOLIDAY = 0x84;
export const GET_HOLIDAYS = 0x85;
export const REMOVE_HOLIDAY = 0x86;
export const SORT_HOLIDAY = 0x87;
export const EXPORT_CUSTOMERS_REPORT = 0x88;
export const EXPORT_CREDIT_REPORT = 0x89;
export const GET_QUOTES = 0x90;
export const SET_QUOTES_FILTER = 0x91;
export const UPDATE_QUOTE = 0x92;
export const SORT_QUOTATION = 0x93;
export const GET_PAYMENT_TERMS = 0x94;
export const ADD_PAYMENT_TERMS = 0x95;
export const REMOVE_PAYMENT_TERMS = 0x96;